import { Td, Tr } from '@chakra-ui/react';
import { formatPrice } from '../../../utils/formatPrice';

export function TotalRow({ totalMktPerVendedor, totalMktPerChamado, totalMktPerPedido, items }) {
  return (
    <Tr bg="gray.200">
      <Td borderRight="1px solid #cecece!important" colSpan="5" textAlign="right" fontWeight="bold">
        Total
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold">
        {items?.totalPedidos}
      </Td>

      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold">
        {items?.soma_total_pedidos_clientes_novos}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold">
        {items?.totalValorPedidos}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold">
        {items?.totalPedCadastra}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold">
        {formatPrice(totalMktPerVendedor)}
      </Td>
      <Td borderRight="1px solid #cecece!important" textAlign="center" fontWeight="bold"></Td>
      <Td textAlign="center" fontWeight="bold"></Td>
    </Tr>
  );
}
